// extracted by mini-css-extract-plugin
export default {"errorButtons":"Error_errorButtons__Oychd","errorBtnClose":"Error_errorBtnClose__vBKUA","errorBtnReport":"Error_errorBtnReport__ybC99"};